module.exports = ".echart {\r\n  position: absolute;\r\n  width: calc(100% - 10px);\r\n  height: 100%;\r\n  margin: 0 5px;\r\n}\r\n"